import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {APPCONFIG} from '../../app.config';
import {MenuService} from '../../core/menu/menu.service';
import {MENU} from '../../routes/menu';
import {HeadquarterInfo} from "../../core/interfaces/headquarter.interface";
import {CompanyInfo} from "../../core/interfaces/company.interface";
import {CodeRole} from "../../core/interfaces/user.interface";

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    public loading = true;
    public userInfo: any = null;
    public manageableCompanies: CompanyInfo[] = []
    public currentCompany: CompanyInfo
    public userCompany: CompanyInfo
    public userHeadquarter: HeadquarterInfo
    public lng = new BehaviorSubject<string>('');
    dialogObservable = this.lng.asObservable();

    mediaLoaded = new Subject<any>();
    bootstrapData: any

    constructor(public menuService: MenuService) {
        this.setLoggedUserInfo();
    }

    public hasHq() {
        return this.userHeadquarter != null
    }

    public hqId() {
        return this.hasHq() ? this.userHeadquarter.id : null
    }

    goStockCompanies(): any[] {
        return this.userInfo.companies.filter(c => c.goStock)
    }

    headquarters(company: number): Array<HeadquarterInfo> {
        const companies = this.userInfo.companies as []
        const found = companies.find(c => c['id'] == company)
        return found != null ? found['headquarters'] : [];
    }

    changeDialogState(value: string): void {
        this.lng.next(value);
    }

    userInfoLoaded(userInfo: any) {
        this.onUserInfo(userInfo)
        this.storeUserInfo(userInfo)
    }

    setLoggedUserInfo() {
        const userInfoJson = localStorage.getItem("userInfo");
        if (userInfoJson) {
            const userInfo = JSON.parse(userInfoJson);
            this.onUserInfo(userInfo)
        } else {
            this.userInfo = null;
        }
    }

    private onUserInfo(userInfo: any) {
        if (userInfo && userInfo != null) {

            this.userInfo = userInfo;
            this.bootstrapData = userInfo.bootstrapData;
            this.manageableCompanies = this.userInfo.companies.filter(c => c.manageable)
            const cmp = this.userInfo.companies.find(c => c.id == this.userInfo.company)
            this.userCompany = cmp
            this.currentCompany = this.userCompany

            if(this.userInfo.headQuarter) {
                this.userHeadquarter = this.userInfo.companies
                    .find((c) => c.headquarters.some((h) => h.id == this.userInfo.headQuarter.id))?.headquarters
                    .find((h) => h.id == this.userInfo.headQuarter.id);
            } else {
                this.userHeadquarter = null;
            }

            // this.userHeadquarter = this.userInfo.companies[1].headquarters[0] // CARR
            // this.userHeadquarter = this.userInfo.companies[2].headquarters[1] // BLUNI

            if (this.userInfo) {
                APPCONFIG.userRole = this.userInfo.role;
                this.setUserMenu(this.userInfo.role);
            }
        } else {
            this.userInfo = null;
        }
    }

    getLoggedUserInfo() {
        return this.userInfo;
    }

    setUserMenu(role: any) {
        this.menuService.addMenu(MENU, role);
    }

    brkRef(obj: any) {
        return JSON.parse(JSON.stringify(obj));
    }

    public storeUserInfo(dataResponse) {
        localStorage.setItem("name", dataResponse.name);
        localStorage.setItem("surname", dataResponse.surname);
        localStorage.setItem("role", dataResponse.role);
        localStorage.setItem("token", dataResponse.token);
        localStorage.setItem("userInfo", JSON.stringify(dataResponse));
        if (dataResponse.role !== CodeRole.SUPERADMIN) {
            localStorage.setItem("company", dataResponse.company);
            localStorage.setItem("companyName", dataResponse.companyName);
        } else {
            localStorage.removeItem("company"); // Removed to avoid errors due to cached value
            localStorage.removeItem("companyName"); // Removed to avoid errors due to cached value
        }
        this.loading = false
    }
}
